// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__1Fyh0","tab":"ProcedureTabs_tab__3jnQA"};